// src/components/Modal.tsx
import React, { useState, useEffect, CSSProperties } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
}

const MOBILE_BREAKPOINT = 480; // ピクセル単位

// ウィンドウ幅を取得するカスタムフック（リサイズ対応）
const useWindowWidth = (): number => {
  const [width, setWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return width;
};

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  const windowWidth = useWindowWidth();

  if (!isOpen) return null;

  // 各コンポーネントのインラインスタイル
  const overlayStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.7)', // 白がかった背景
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  };

  const modalCardStyle: CSSProperties = {
    position: 'relative',
    backgroundColor: '#fff',
    width: '500px', // モーダル幅(適宜調整)
    maxWidth: '80%',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  };

  const closeButtonStyle: CSSProperties = {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    background: 'transparent',
    border: 'none',
    fontSize: windowWidth <= MOBILE_BREAKPOINT ? '2.8rem' : '1.2rem',
    cursor: 'pointer',
  };

  // クリックした要素が Overlay 自身の場合のみ onClose を実行
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div style={overlayStyle} onClick={handleOverlayClick}>
      <div style={modalCardStyle}>
        <button style={closeButtonStyle} onClick={onClose}>
          ×
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
